import { render, staticRenderFns } from "./DamageType.vue?vue&type=template&id=3f7590b7&scoped=true"
import script from "./DamageType.vue?vue&type=script&lang=ts"
export * from "./DamageType.vue?vue&type=script&lang=ts"
import style0 from "./DamageType.vue?vue&type=style&index=0&id=3f7590b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7590b7",
  null
  
)

export default component.exports